import Link from "next/link";
import useSite from "hooks/use-site";
// import { postPathBySlug } from 'lib/posts';
// import { categoryPathBySlug } from 'lib/categories';
import useMedia from "hooks/use-media";
import Section from "components/Section";
import Container from "components/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import TextParagraph from "components/SectionText/TextParagraph";
import Logo from "components/Logo";
import styles from "./Footer.module.scss";
import { useEffect, useState } from "react";
import { getMenuBylocationV2 } from "data/fetchPlugin";

const text = {
  th: {
    address: {
      desktop: `เลขที่ 200 หมู่ 4 ชั้น 9 จัสมิน อินเตอร์เนชั่นแนล ทาวเวอร์\nถนนแจ้งวัฒนะ ตำบลปากเกร็ด อำเภอปากเกร็ด จังหวัดนนทบุรี 11120`,
      mobile: `เลขที่ 200 หมู่ 4 ชั้น 9 จัสมิน อินเตอร์เนชั่นแนล ทาวเวอร์\nถนนแจ้งวัฒนะ ตำบลปากเกร็ด อำเภอปากเกร็ด\nจังหวัดนนทบุรี 11120`,
    },
    cookiePolicy: "นโยบายการใช้คุ้กกี้",
    privacyPolicy: "คำประกาศเกี่ยวกับความเป็นส่วนตัว",
  },
  en: {
    address: {
      desktop:
        "200 Moo 4, 9th Floor, Jasmine International Tower\nChaengwatana Road, Tambon Pakkret, Amphoe Pakkret, Nonthaburi 11120",
      mobile:
        "200 Moo 4, 9th Floor, Jasmine International Tower\nChaengwatana Road, Tambon Pakkret, Amphoe Pakkret\nNonthaburi 11120",
    },
    cookiePolicy: "Cookies Policy",
    privacyPolicy: "Privacy Notice",
  },
};

const Footer = () => {
  const [menuFooter, setMenuFooter] = useState(null)
  const [menuFooterLegal, setMenuFooterLegal] = useState(null)
  let isSm = useMedia("(max-width: 768px)");
  const { locale, showUi, siteData } = useSite();
  let lang = locale.toLowerCase();
  const siteTitle = siteData?.title || "";
  const hasMenu = Array.isArray(menuFooter) && menuFooter.length > 0;
  const hideSocialLink =
    typeof showUi?.status === "undefined"
      ? !Number(
          showUi?.find(u => u.slug === "FOOTER_SOCIAL_LINK")?.is_show || true,
        )
      : true;

  useEffect(() => {
      (async () => {
        if (locale) {
          const menuFooter = await getMenuBylocationV2(locale.toLowerCase(), "footer");
          if (menuFooter) {
            setMenuFooter(menuFooter)
          }
          const menuFooterLegal = await getMenuBylocationV2(
            locale.toLowerCase(),
            "footer-legal",
          );
          if (menuFooterLegal) {
            setMenuFooterLegal(menuFooterLegal)
          }
        }
      })()
    }, [locale])

  return (
    <footer className={styles.footer}>
      {hasMenu && (
        <Section className={styles.footerMenu}>
          <Container className={styles.footerMenuWrap}>
            <div className={styles.footerMenuAddress}>
              <h1>
                <Logo customWidth={120} customHeight={55} isCustom={true} />
              </h1>
              <TextParagraph>
                {isSm ? text[lang].address.mobile : text[lang].address.desktop}
              </TextParagraph>
            </div>
            <ul className={styles.footerMenuColumns}>
              <li>
                <p className={styles.footerMenuTitle}>
                  <strong>Menu</strong>
                </p>
                {menuFooter && (
                  <ul className={styles.footerMenuItems}>
                    {menuFooter?.map(({ id, path, label, title, target }) => {
                      return (
                        <li key={id}>
                          {!path.includes("http") && !target && (
                            <Link href={path}>
                              <a title={title}>{label}</a>
                            </Link>
                          )}
                          {path.includes("http") && (
                            <a href={path} title={title} target={target}>
                              {label}
                            </a>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
              {!hideSocialLink && (
                <li>
                  <p className={styles.footerMenuTitle}>
                    <strong>Follow Us</strong>
                  </p>
                  <ul
                    className={`${styles.footerMenuItems} ${styles.footerMenuItemSocial}`}>
                    <li>
                      <a href="#" target="_blank">
                        <span className={styles.socialIcon}>
                          <FontAwesomeIcon icon={faFacebookF} size="lg" />
                        </span>
                        <span className={styles.title}>Facebook</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <span className={styles.socialIcon}>
                          <FontAwesomeIcon icon={faTwitter} size="lg" />
                        </span>
                        <span className={styles.title}>Twitter</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <span className={styles.socialIcon}>
                          <FontAwesomeIcon icon={faInstagram} size="lg" />
                        </span>
                        <span className={styles.title}>Instagram</span>
                      </a>
                    </li>
                  </ul>
                </li>
              )}
            </ul>
          </Container>
        </Section>
      )}

      <Section className={styles.footerLegal}>
        <Container className={styles.footerLegelWrapper}>
          <p className={styles.copyRight}>
            &copy; {new Date().getFullYear()}. {siteTitle}. All rights reserved.
          </p>
          <ul className={styles.infomation}>
            <li>
              <Link href={'/ckie-policy'}>
                <a title={text[lang].cookiePolicy}>{text[lang].cookiePolicy}</a>
              </Link>
            </li>
            {menuFooterLegal?.length > 0 &&
              menuFooterLegal.map((item, index) => (
                <li key={index}>
                  <a href={item.url}>{item.label}</a>
                </li>
              ))}
          </ul>
        </Container>
      </Section>
    </footer>
  );
};

export default Footer;
